'use client'

import { ResendConfirmationForm } from '../ResendConfirmation/Form'

import { Card, CardHeader, CardTitle, CardBody } from '@/shared/ui/Card'

export function ResendConfirmationPage() {
  return (
    <Card className="max-w-md">
      <CardHeader>
        <CardTitle>Reenviar confirmação</CardTitle>
      </CardHeader>
      <CardBody className="text-dark">
        <ResendConfirmationForm />
      </CardBody>
    </Card>
  )
}
